"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearcherDatepickerDesktop = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _ru = _interopRequireDefault(require("date-fns/locale/ru"));
var _Calendar = require("../Calendar");
var _CustomCheckbox = _interopRequireDefault(require("../Checkbox/CustomCheckbox"));
var _SearcherFlexBadge = _interopRequireDefault(require("../SearcherFlexBadge"));
var _SearchSelect = require("../SearchSelect");
var _utils = require("./utils");
// Components:

// Interfaces:

// Utils and constants:

var SearcherDatepickerDesktop = exports.SearcherDatepickerDesktop = function SearcherDatepickerDesktop(props) {
  var selectedDate = props.selectedDate,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$currentDate = props.currentDate,
    currentDate = _props$currentDate === void 0 ? new Date() : _props$currentDate,
    _props$flexDates = props.flexDates,
    flexDates = _props$flexDates === void 0 ? false : _props$flexDates,
    _props$showFlexDates = props.showFlexDates,
    showFlexDates = _props$showFlexDates === void 0 ? false : _props$showFlexDates,
    _props$onChangeDate = props.onChangeDate,
    onChangeDate = _props$onChangeDate === void 0 ? Function.prototype : _props$onChangeDate,
    _props$onChangeFlexDa = props.onChangeFlexDate,
    onChangeFlexDate = _props$onChangeFlexDa === void 0 ? Function.prototype : _props$onChangeFlexDa,
    _props$multipleMonth = props.multipleMonth,
    multipleMonth = _props$multipleMonth === void 0 ? false : _props$multipleMonth,
    CustomControl = props.CustomControl,
    CustomLabel = props.CustomLabel;
  var handleChange = function handleChange(val) {
    onChangeDate(val);
  };
  var handleChangeFlex = function handleChangeFlex() {
    return onChangeFlexDate();
  };
  var CustomOption = function CustomOption(optionProps) {
    var _ref = optionProps,
      innerRef = _ref.innerRef,
      onClick = _ref.onClick;
    var onChange = function onChange(date) {
      handleChange(date);
      onClick();
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: innerRef
    }, /*#__PURE__*/_react["default"].createElement(_Calendar.Calendar, {
      className: className,
      selected: selectedDate,
      onChange: onChange,
      minDate: (0, _utils.getMinDate)(currentDate),
      maxDate: (0, _utils.getMaxDate)(currentDate),
      monthsShown: multipleMonth ? 2 : 1
    }), showFlexDates ? /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
      checked: flexDates,
      onChange: handleChangeFlex
    }, "\xB12 \u0434\u043D\u044F \u043E\u0442 \u0434\u0430\u0442\u044B \u0432\u044B\u043B\u0435\u0442\u0430") : null);
  };
  var Option = {
    custom: true,
    CustomComponent: CustomOption
  };
  var CustomDropdownIndicator = CustomControl ? function () {
    return null;
  } : undefined;
  var SingleValue = CustomControl && CustomLabel ? CustomLabel : function (singleValueProps) {
    var innerProps = singleValueProps.innerProps,
      selectProps = singleValueProps.selectProps;
    var menuIsOpen = selectProps.menuIsOpen;
    return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({}, innerProps, {
      menuIsOpen: menuIsOpen
    }), /*#__PURE__*/_react["default"].createElement("span", null, (0, _format["default"])(selectedDate, 'd MMMM', {
      locale: _ru["default"]
    })), flexDates && /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, null));
  };
  var customStyles = {
    menu: function menu() {
      return {
        width: 'auto',
        maxWidth: 'auto'
      };
    },
    menuList: function menuList() {
      return {
        maxHeight: 'auto'
      };
    },
    valueContainer: function valueContainer() {
      return {
        padding: 0,
        flexWrap: 'initial'
      };
    },
    indicatorsContainer: function indicatorsContainer() {
      return {
        alignSelf: 'unset'
      };
    },
    dropdownIndicator: function dropdownIndicator() {
      return {
        padding: 0,
        paddingLeft: 4
      };
    },
    control: function control() {
      return {
        minHeight: 'unset',
        height: 'unset'
      };
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    options: [Option],
    customStyles: customStyles,
    isSearchable: false,
    isClearable: false,
    CustomSingleValue: SingleValue,
    CustomDropdownIndicator: CustomDropdownIndicator,
    captureMenuScroll: false,
    menuShouldBlockScroll: false
  });
};
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDatepickerdesktop__StyledLabel",
  componentId: "sc-64vkr-0"
})(["display:flex;align-items:center;font-size:16px;line-height:20px;white-space:nowrap;flex-wrap:initial;font-weight:500;color:", ";"], function (_ref2) {
  var menuIsOpen = _ref2.menuIsOpen,
    theme = _ref2.theme;
  return menuIsOpen ? theme.colors.lightGrey : theme.colors.blackBase;
});
var StyledSearcherFlexBadge = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "SearcherDatepickerdesktop__StyledSearcherFlexBadge",
  componentId: "sc-64vkr-1"
})(["margin-left:5px;margin-top:2px;display:flex;align-items:center;justify-content:center;"]);
var StyledCheckbox = (0, _styledComponents["default"])(_CustomCheckbox["default"]).withConfig({
  displayName: "SearcherDatepickerdesktop__StyledCheckbox",
  componentId: "sc-64vkr-2"
})(["height:50px;display:flex;justify-content:center;align-items:center;user-select:none;outline:0;box-shadow:inset 0 1px 0 #c2c5cc;input{outline:0;}"]);